const texts = {
    "exchange-failed-page.error": {
        EN: "Something went wrong with the payment.",
        DA: "Noget gik galt med betalingen.",
        DE: "Etwas ist mit der Zahlung schiefgelaufen.",
        NL: "Er is iets misgegaan met de betaling.",
        FR: "Un problème est survenu avec le paiement.",
        IT: "Qualcosa è andato storto con il pagamento.",
        ES: "Algo salió mal con el pago.",
        PT: "Algo deu errado com o pagamento.",
        FI: "Jokin meni pieleen maksun kanssa.",
        SV: "Något gick fel med betalningen.",
        NO: "Noe gikk galt med betalingen.",
    },
    "exchange-failed-page.intro": {
        EN: "Please contact support at",
        DA: "Kontakt venligst support på",
        DE: "Bitte kontaktieren Sie den Support unter",
        NL: "Neem contact op met de klantenservice via",
        FR: "Veuillez contacter l'assistance à l'adresse",
        IT: "Contatta l'assistenza all'indirizzo",
        ES: "Ponte en contacto con soporte en",
        PT: "Entre em contato com o suporte em",
        FI: "Ota yhteyttä asiakaspalveluun osoitteessa",
        SV: "Vänligen kontakta kundtjänst på",
        NO: "Vennligst kontakt kundestøtte på",
    },
    "payment-exchange-cost": {
        EN: "Exchange cost",
        DA: "Omkostning ved ombytning",
        DE: "Umtauschkosten",
        NL: "Ruilkosten",
        FR: "Frais d'échange",
        IT: "Costo di cambio",
        ES: "Costo de cambio",
        PT: "Custo de troca",
        FI: "Vaihdon kustannus",
        SV: "Byteskostnad",
        NO: "Kostnad ved bytte",
    },
};
export default texts;
